var exports = {
  "fs": "SpaceBackground.module__starfield___NzVqbz",
  "hi": "SpaceBackground.module__spaceBackground___NzVqbz" + " " + "SpaceBackground.module__starfield___NzVqbz",
};

module.exports = exports;
